import { get } from 'svelte/store';
import { getAppConfig } from '../../../common/config/app-config';
import { pdpServicesGtmData, pdpServicesMixpanelData, productDetails, productQuantity } from '../store/pdp_store';
import { getSponsoredFlag_PDP, isRMNSourcedPDP } from './pdp-data-services';

export function getCommonPdpMixpanelData(eventName) {
  const productDetailsData = get(productDetails);
  const { marketPlaceProduct, marketPlaceOfferData, marketPlaceShopDetails } = productDetailsData || {};
  let dataObj = {
    cart_id: window['ACC'].mixpanel.var.cartCode,
    product_id: productDetailsData.code,
    name: productDetailsData.nameEn,
    brand: productDetailsData.brandNameEn,
    price: productDetailsData.price?.value,
    discount_price: productDetailsData.discountPrice ? productDetailsData.discountPrice.value : 0,
    currency: window.ACC.config.currency,
    item_category1: productDetailsData.pageCategoryNameEn || null,
    item_category2: productDetailsData.pageSubCategoryNameEn || null,
    item_category3: productDetailsData.rmsCategoryNameEn || null,
    source_name: window['ACC'].utils.getSourceNameForCurrentPage(),
    delivery_category:
      productDetailsData.standardDeliveryCost !== null ? productDetailsData.standardDeliveryCost.value : 0,
    quantity: get(productQuantity),
    marketplace_product_flag: marketPlaceProduct ? 'Yes' : 'No',
    seller_name: marketPlaceOfferData?.shopName ?? 'extra',
    seller_rating: marketPlaceShopDetails?.grade ?? '',
    extra_product_rating: '',
    product_variation_code: '',
    is_online_only: productDetailsData.onlineOnlyItem ? 'Yes' : 'No',
    sponsored_flag: getSponsoredFlag_PDP(),
  };
  if (getAppConfig().productQtyUpdateEnabled) {
    dataObj['quantity'] = get(productQuantity);
  }
  if (eventName === 'Added to Cart' || eventName === 'Pre Order Now') {
    const primeType = getAppConfig().primeLevel || 'NOPRIME';
    let productType = '';
    if (primeType === 'NOPRIME' || primeType === 'VIPPRIME') {
      productType = 'productVipPrimeData';
    } else if (primeType === 'BASICPRIME') {
      productType = 'productBasicPrimeData';
    } else if (primeType === 'SMARTPRIME') {
      productType = 'productSmartPrimeData';
    }
    dataObj['jood_day_flag'] = productDetailsData?.[productType]?.tacticalPromo ? 'Yes' : 'No';
    dataObj['rmn_flag'] = isRMNSourcedPDP() ? 'Yes' : 'No';
    dataObj['is_recommendation'] = window['ACC'].utils.getRecommendationFlag() ? 'Yes' : 'No';
    dataObj['is_chatbot'] = window['ACC'].utils.getChatBotFlag() ? 'Yes' : 'No';
  }
  if (eventName === 'Product Added to Wishlist') {
    delete dataObj['quantity'];
    delete dataObj['delivery_category'];
  } else {
    // get service related mixpanel data
    const servicesMPData: any = get(pdpServicesMixpanelData);
    if (servicesMPData) {
      delete servicesMPData.service_id;
      const additionalProperties = {
        recommended_service_flag: 'N',
        service_source: window['ACC'].constants.PAGESOURCE.PRODUCTDETAIL,
      };
      dataObj = Object.assign({}, dataObj, servicesMPData, additionalProperties);

      const { name: product_name, product_id, item_category1, item_category2, item_category3, cart_id } = dataObj;
      const serviceAddedEventData = {
        ...servicesMPData,
        ...{ product_name, product_id, item_category1, item_category2, item_category3, cart_id },
        ...additionalProperties,
      };
      window['ACC'].mixpanel.track('Service Added to Cart', serviceAddedEventData);
    }

    const servicesMPDataGtm: any = get(pdpServicesGtmData);
    if (servicesMPDataGtm) {
      let serviceData = [];
      serviceData = servicesMPDataGtm.map(function (sd) {
        return {
          id: sd.service_id,
          title: sd.service_name.toLowerCase(),
          price: sd.service_fees,
          quantity: 1,
        };
      });
      window['ACC'].extragtm.var.services = serviceData;
    }
  }

  console.log('dataObj', dataObj);
  return dataObj;
}
